import { FC } from "react";
import { IoIosRocket } from "@react-icons/all-files/io/IoIosRocket";
import { Button, useDisclosure } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useBilling, useLoggedinUser, useTeam } from "lib/hooks";
import { VerifyAlertDialog } from "../alert-dialogs";

const validStatuses = [
  'active',
  'trial',
]

export const UpgradeButton: FC = () => {
  const { data: user } = useLoggedinUser();
  const { data: team, isLoading } = useTeam();
  const router = useRouter();
  const verifyDialog = useDisclosure();

  if (isLoading || team.subscription_has_payment_method) {
    return null;
  }

  const onClick = (): void | Promise<boolean> => (
    user?.verified ? router.push('/upgrade-account') : verifyDialog.onOpen()
  )

  return (
    <>
      <Button
        display={['none', 'none', 'none', 'inherit']}
        leftIcon={<IoIosRocket />}
        size={"sm"}
        variant={"primary"}
        onClick={onClick}
      >
        Upgrade
      </Button>
      <VerifyAlertDialog
        isOpen={verifyDialog.isOpen}
        onClose={verifyDialog.onClose}
        content={`To upgrade your account, you need to complete your account set up. It’s super easy. We sent a verification link to ${user?.email}. Please go to your inbox and click that link to get full access to your Packs account.`}
        title={"You’re so close! One final step."}
      />
    </>
  )
}
